import { userConstants } from "../actions/constants/userConstants";

export const roleDataReducer = (state = {}, action: any) => {
    switch (action.type) {
        case userConstants.roleUserRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case userConstants.roleUserSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                roleData: action.payload
            }
        case userConstants.roleUserFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}

export const userCreateReducer = (state = {}, action: any) => {
    switch (action.type) {
        case userConstants.userCreateRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case userConstants.userCreateSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                userData: action.payload
            }
        case userConstants.userCreateFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        case userConstants.userCreateReset:
            return {
                isLoading: false,
                isSuccess: false,
                isError: false,
                userData: null
            }
        default:
            return state;
    }
}

export const userListReducer = (state = {}, action: any) => {   
    switch (action.type) {
        case userConstants.userListRequest:
            return {
                ...state,
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case userConstants.userListSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                userList: action.payload
            }
        case userConstants.userListFailure:
            return {
                ...state,
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}

export const userUpdateReducer = (state = {}, action: any) => {
    switch (action.type) {
        case userConstants.userUpdateRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case userConstants.userUpdateSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                updatedUser: action.payload
            }
        case userConstants.userUpdateFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}

export const userViewReducer = (state = {}, action: any) => {
    switch (action.type) {
        case userConstants.userViewRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case userConstants.userViewSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                userData: action.payload
            }
        case userConstants.userViewFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}


export const getProfileReducer = (state = {}, action: any) => {
    switch (action.type) {
        case userConstants.getProfileRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case userConstants.getProfileSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                profileData: action.payload
            }
        case userConstants.getProfileFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}

export const updateProfileReducer = (state = {}, action: any) => {
    switch (action.type) {
        case userConstants.updateProfileRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case userConstants.updateProfileSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                profileData: action.payload
            }
        case userConstants.updateProfileFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}

export const updateProfileImageReducer = (state = {}, action: any) => {
    switch (action.type) {
        case userConstants.uploadProfileImageRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case userConstants.uploadProfileImageSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                profileImage: action.payload
            }
        case userConstants.uploadProfileImageFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}

export const getTermsByTypeReducer = (state = {}, action: any) => {
    switch (action.type) {
        case userConstants.getTermsByTypeRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case userConstants.getTermsByTypeSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                termsData: action.payload
            }
        case userConstants.getTermsByTypeFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}

export const getInstructorHistoryReducer = (state = {}, action: any) => {
    switch (action.type) {
        case userConstants.getInstructorHistoryRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false,
            }
        case userConstants.getInstructorHistorySuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                historyData: action.payload,
            }
        case userConstants.getInstructorHistoryFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload,
            }
        case userConstants.getInstructorHistoryReset:
            return {}
        default:
            return state;
    }
}

export const sendInvitationReducer = (state = {}, action: any) => {
    switch (action.type) {
        case userConstants.sendInvitationRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false,
            }
        case userConstants.sendInvitationSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                message: action.payload,
            }
        case userConstants.sendInvitationFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload,
            }
        default:
            return state;
    }
}
